import {store as reportConf} from 'bjxy-report'

const reporter = reportConf({projectId: process.env.NODE_ENV === 'production' ? 'wallet_h5': 'test' })

export default {
  state: {

  },
  mutations: {
    config (state, payload) {
      Object.assign( state.config, payload);
    }
  },
  modules: Object.assign({}, reporter),
}



// WEBPACK FOOTER //
// ./src/module/blueRegPage/index/store.js